module.exports = "/fonts/vendor/@fortawesome/fontawesome-free/webfa-brands-400.woff2?715d593456fa02fe72a008a72398f5be";